export default "__VITE_ASSET__DiykJ_Pm__"